import { DelayWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Delay')
export class DelayNodeSchemaProvider extends SchemaProvider<DelayWorkflowNode> {}
